<template>
  <div>
    <tableCommon
        :scrollWidth="500"
        :ref="`tableAboutSeat`"
        :config="tableConfig"
        :defaultShowColumn="[]"
        :showPagenation="false"
        :table-data="tableData"
        :table-item="tableItems"
    ></tableCommon>
  </div>
</template>

<script>
import tableCommon from '@/components/common/vueTable'
export default {
  name: "quotaTable",
  props: {
    quotaDetail: {},
    classification: {}
  },
  data() {
    return {
      quotaTypeList: {
        1: '电话随访成功+失访+拒随',
        2: '电话随访成功',
        3: '失访',
        4: '拒随',
        5: '电话随访成功+失访',
        6: '电话随访成功+拒随',
        7: '失访+拒随',
        8: '呼叫人数',
        9: '处理异常(随访成功)',
        10: '处理异常(呼叫人数)',
        11: '特殊指标',
      },
      tableConfig: {
        cellStyleOption: {
          bodyCellClass: ({row, column, rowIndex}) => {
            if (row[column.key] && (row[column.key].quotaType == 9 || row[column.key].quotaType == 10)) {
              return 'purple'
            }

            if (row[column.key] && row[column.key].quotaType == 11) {
              return 'blue'
            }
          }
        },
        rowKey: 'id',
        maxHeight: '600px',
        checkBoxOption: {
          selectedRowChange: ({row, isSelected, selectedRowKeys}) => {
          },
          // 全选改变事件
          selectedAllChange: ({isSelected, selectedRowKeys}) => {
          },
        },
        columnHiddenOption: {}
      },
      tableData:[],
      tableItems:[
        {width: 100, field: "id", key: "id", title: "任务ID",},
        {width: 100, field: "name", key: "name", title: "任务名称",},
        {width: 100, field: "totalQuotaNumber", key: "totalQuotaNumber", title: "总指标",},
        {width: 100, field: "totalCallQuotaFinishNumber", key: "totalCallQuotaFinishNumber", title: "呼叫量",renderBodyCell: this['renderBodyCelltotalSuccessQuotaCallFinishNumber']},
        {width: 100, field: "totalSuccessQuotaFinishNumber", key: "totalSuccessQuotaFinishNumber", title: "成功量",renderBodyCell: this['renderBodyCelltotalSuccessQuotaFinishNumber']},
      ],
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    renderBodyCelltotalSuccessQuotaCallFinishNumber({row, column, rowIndex}) {
      let vm = this
      console.log(vm.classification);
      return (
          <div class={row['callDataColor'] ? (row['callDataColor'] == 1 ? 'redT' : 'greenT') : ""}>
            { vm.classification == 3 ? row.totalCallQuotaNumber :  `${row.totalCallQuotaFinishNumber}(${row.totalCallQuotaNumber})`}
          </div>
      )
    },
    renderBodyCelltotalSuccessQuotaFinishNumber({row, column, rowIndex}) {
      let vm = this
      console.log(vm.classification);
      return (
          <div class={row['successDataColor'] ? (row['successDataColor'] == 1 ? 'redT' : 'greenT') : ""}>
            { vm.classification == 3 ? row.totalSuccessQuotaNumber :  `${row.totalSuccessQuotaFinishNumber}(${row.totalSuccessQuotaNumber})`}
          </div>
      )
    },
    init() {
      if(this.quotaDetail.tableInfo.length) {
        this.tableData = this.quotaDetail.tableInfo.map(item => {
          item.indexConfigDetailList.forEach(_it => {
            item[_it.quotaDate] = _it
          })
          return item
        })
        let arr = this.quotaDetail.tableInfo[0].indexConfigDetailList.map(item => {
          let obj = {}
          obj.width = 100
          obj.field = item.quotaDate
          obj.key = item.quotaDate
          obj.title = item.quotaDate
          obj.renderBodyCell = ({row, column, rowIndex}) => {
            return (
                <div>{getRowText(row[column.key],item)}</div>
            )
          }
          return obj
        })
        let vm = this
        function getRowText(row,item) {
          if (row) {
            console.log(item);
            return (
                <div class={row['dataColor'] ? (row['dataColor'] == 1 ? 'redT' : 'greenT') : ""}>
                  <span>{row.otherName}</span>
                  <span>{ row.quotaType == 11 ? row.specialQuota : row.quotaTypeStr}</span>
                  <br/>
                  {
                    [9, 10].indexOf(row.quotaType) == -1 ?
                        <span>{ vm.classification == 3 ? `${row.distributeQuotaNumber}` : row.finishQuotaNumber + `（${row.distributeQuotaNumber}）` }</span>
                        :
                        ""
                  }
                </div>
            )
          } else {
            return (<span>未设置</span>)
          }

        }

        this.tableItems.push(...arr)
      }
    },
  },
  components: {
    tableCommon
  }
}
</script>
<style>
.purple {
  background-color: rgba(231, 182, 249, 1) !important;
}

.blue {
  background-color: rgba(178, 207, 255, 1) !important;
}

.redT {
  color: red !important;
}

.greenT {
  color: green !important;
}
</style>
<style scoped>

</style>